(function () {
    angular.module("tmx-app").directive("tmxSection", ["$filter", '$timeout',
        function tmxSection($filter, $timeout) {
            return {
                scope: {
                    title: '@',
                    addButton: '@',
                    addFile: '@',
                    downloadFile: '@',
                    onAdd: '&',
                    onChildAdd: '&',
                    afterImport: '&',
                    exportFile:'&',
                    errMsg: '@',
                    isErr: '@',
                    isDisabled: '@',
                    isRequired: '@',
                    isChild: '@',
                    initCollapsed: '@',
                    dynamicTitle:'='
                },
                restrict: 'E',
                transclude: true,
                replace: true,
                template: function (element, scope) {
				// var inside = 'x';
                    var content = element[0].innerHTML;
				// var title = scope.title;
				// var heading = scope.title
                    var heading = $filter('translate')(scope.title);
                    var errMsg = scope.errMsg;
                    var asterisk = "*";
				// var color = scope.color ? 'style="background-color: ' + scope.color + '"' : "";
                    var title = '';
                    if (heading || scope.dynamicTitle) {
                        title = ' <div class="sub-header-min layout-row" style="line-height:64px;">' +
						'<label style="color:#424242; font-weight:bold;">{{headingTitle}}<span style="margin-top:7px; color: red; font-size: 85%;" ng-if="isRequired==\'true\'">' + asterisk + '</span></label>';

                        if (scope.addButton) {
                            title += '<md-button ng-if="!($state.current.name.includes(\'.info\'))" class="md-icon-button md-mini margin-12" style="margin-top:4px;" ng-click="add($event)" ng-disabled="isDisabled==\'true\'">' +
							'<md-icon class="phoneicons material-icons md-primary"  >add_circle</md-icon>' +
							'<md-tooltip>Add</md-tooltip>' +
							'</md-button>';
                        }
                        if (scope.addFile) {
						

                            title +=	'<tmx-upload-excel-file  url="Batch/BulkUpload" should-show-response-dialog="false" after-upload="afterImport()" accept-files=".xlsx"> </tmx-upload-excel-file>';
                        }
                        if (scope.downloadFile) {												
                            title +=	'<md-button class="topbar-menu-button" aria-label="Export" ng-click="exportFile()" >'+
						' <md-icon > file_download</md-icon>'+
						'<md-tooltip>Export</md-tooltip>' +
						'</md-button>';
                        }
					
					
                        if (scope.errMsg) {
                            title += '<span style="color:red" ng-if="isErr==\'true\'">' + errMsg + '</span>';//class="required-error" 
                        }

                        title += '<span flex></span>' +
						'<button class="md-button md-primary section-toggle" ng-click="toggle($event)">' +
						'<md-icon style="margin-top: 5px;" ng-if="collapsed" class="ng-scope ng-isolate-scope material-icons md-toggle-icon toggled active">keyboard_arrow_down</md-icon>' +
						'<md-icon style="margin-top: 5px;" ng-if="!collapsed" class="ng-scope ng-isolate-scope material-icons md-toggle-icon toggled active">keyboard_arrow_up</md-icon>' +
						'</button>' +
						'</div> ';
                    }
                    return ['<div class="white-background-editscreen"">',
                        title,
					//this is the container for the original innerHTML, transcluded
                        '<div class="section-content"><div layout="row" flex  id="section-content" layout-wrap ng-transclude style="padding-top:16px;padding-bottom:24px;padding-left:12px;padding-right:12px;">' +
					content, //this may contain {{template code}}, and gets transcluded
                        '</div></div>'
                    ].join("\n");
                },
                controller: function ($scope, $element) {

                    $scope.collapsed = $scope.initCollapsed == 'true';
                    $scope.toggle = function ($event) {
                        if ($event) {
                            $event.stopPropagation();
                        }
                        $($element.find('.section-content')).slideToggle(250);
                        $scope.collapsed = !$scope.collapsed;
                    };

                    $scope.add = function ($event) {
                        $event.stopPropagation();

                        if ($scope.isChild == 'true') {
                            $scope.onChildAdd();
                        }
                        else {
                            $scope.onAdd()();
                        }
                    };
			
                    if($scope.dynamicTitle){
                        $scope.headingTitle = $filter('translate')($scope.dynamicTitle);
                    }
                    else
                        $scope.headingTitle = $filter('translate')($scope.title);
                },
                link: function (scope) {
                    $timeout(function () {
                        if (scope.collapsed) {
                            scope.toggle();
                            scope.collapsed = !scope.collapsed;
                        }
                    });

                }
            };
        }]);
})();
